import { IApplicationState } from '../../../../../types/types';

export const isPerformanceAllowedSelector = (
    state: IApplicationState
) => state.cookieDialog.isPerformanceAllowed;
